<template>
  <button
    type="button"
    class="button"
    :class="[classes, pointClass]"
    @click="passMethod('click')"
  >
    <slot></slot>
    <svg
      v-if="loading"
      :style="loadingStyle"
      viewBox="25 25 50 50"
      class="circular"
      :class="buttonLoadingClass"
    >
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        class="path"
        :class="pathLoadingClass"
      ></circle>
    </svg>
  </button>
</template>

<script>
import themeMixins from '@mixins/officialStore/themeMixins'
export default {
  mixins: [themeMixins],
  props: ['tagName', 'loading', 'loadingStyle'],
  computed: {
    buttonLoadingClass() {
      return `ocean-ui-${this.type}-circular`
    },
    pathLoadingClass() {
      return `ocean-ui-${this.type}-path`
    }
  },
  data() {
    return {
      longSyle: false,
      styleConfig: ''
    }
  },
  created() {
    if (undefined !== this.long) {
      this.longSyle = true
    }
    this.styleConfig = {}
  }
}
</script>

<style lang="scss">
.button {
  font-size: 24px;
  color: #999;
}
.circular {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  height: 30px;
  width: 30px;
  animation: loading-rotate 2s linear infinite;
}
.circular .path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #fff;
  stroke-linecap: round;
}
@keyframes loading-rotate {
  100% {
    transform: rotate(1turn);
  }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
</style>
